// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3bxSE","content":"styles_content__2yKbd","buttonIcon":"styles_buttonIcon__37Ufy","standardDescription":"styles_standardDescription__1nFQR"};